<template>
  <div class="card">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <div class="lead">
              {{ $t('vendorManagementRequestDynamicsReport.soruVTkliflrinDinamikas') }}
            </div>
          </div>
          <div class="col-md-6 text-right">
            <download-excel
              :data="reportData"
              name="report.xls"
              class="btn btn-success"
              header="Sorğu və təkliflərin dinamikası"
              :fields="{
                'Əsas fəaliyyət sahəsi':'parentSectorName',
                'Alt fəaliyyət sahəsi':'sectorName',
                'Sorğu tipləri':'requestType',
                'Sorğunun statusu':'requestStatus',
                'Sorğu sayı':'requestCount',
                'Təklif sayı': 'offerCount'}"
            >
              <feather
                type="table"
                size="14"
              />
              {{ $t('newAUCRequest.ykl') }}
            </download-excel>
          </div>
        </div>
      </div>

      <div class="card-body">
        <form action="">
          <div class="row">
            <div class="col-md-4">
              <label class="control-label">{{ $t('vendorManagementPurchasesReports.faliyytSahsi') }}</label>
              <select
                v-model.number="sector"
                class="form-control"
                @change="loadReportData"
              >
                <option :value="0">
                  {{ $t('vendorManagementPurchasesReports.btnFaliyytSahlri') }}
                </option>
                <option
                  v-for="s in sectors"
                  :key="s.id"
                  :value="s.id"
                >
                  {{ s.name }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="control-label">{{ $t('vendorManagementPurchasesReports.status') }}</label>
              <select
                v-model="status"
                class="form-control"
                @change="loadReportData"
              >
                <option value="ALL">
                  {{ $t('vendorManagementPurchasesReports.btnStatuslar') }}
                </option>
                <option value="ACTIVE">
                  {{ $t('changeAccount.aktiv') }}
                </option>
                <option value="EXPIRED">
                  {{ $t('myRequest.mddtiBitmi') }}
                </option>
                <option value="CLOSED">
                  {{ $t('vendorManagementPurchasesReports.bal') }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="control-label">{{ $t('vendorManagementPurchasesReports.soruTiplri') }}</label>
              <select
                v-model="type"
                class="form-control"
                @change="loadReportData"
              >
                <option value="ALL">
                  {{ $t('vendorManagementPurchasesReports.btnSoruTiplri') }}
                </option>
                <option value="RFI">
                  {{ $t('newRequestPopupContent.informasiyaSorusu') }}
                </option>
                <option value="RFQ">
                  {{ $t('newRequestPopupContent.qiymtSorusu') }}
                </option>
                <option value="PQT">
                  {{ $t('vendorManagementPurchasesReports.kotirovkaSorusu') }}
                </option>
                <option value="REV">
                  {{ $t('vendorManagementPurchasesReports.ksHrracSorusu') }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="control-label">{{ $t('vendorManagementPurchasesReports.tarixlr') }}</label>
              <datepicker
                v-model="startDate"
                input-class="datepicker-here form-control digits"
                :format="dateFormat"
              />
            </div>
            <div class="col-md-2">
              <label class="control-label">&nbsp;</label>
              <datepicker
                v-model="endDate"
                input-class="datepicker-here form-control digits"
                :format="dateFormat"
                :disabled-dates="{to: new Date(startDate)}"
                @change="loadReportData"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>{{ $t('vendorManagementPurchasesReports.sasFaliyytSahsi') }}</th>
              <th>{{ $t('vendorManagementPurchasesReports.altFaliyytSahsi') }}</th>
              <th>{{ $t('vendorManagementPurchasesReports.soruTiplri') }}</th>
              <th>{{ $t('vendorManagementPurchasesReports.sorununStatusu') }}</th>
              <th>{{ $t('vendorManagementRequestDynamicsReport.soruSay') }}</th>
              <th>{{ $t('vendorManagementPurchasesReports.tklifSay') }}</th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-if="reportData.length<1">
              <td colspan="6">
                <div class="alert alert-info">
                  {{ $t('requestsByType.axtaraUyunSoruTaplmad') }}
                </div>
              </td>
            </tr>

            <template v-for="s in reportData">
              <tr>
                <td class="text-left">
                  {{ s.parentSectorName }}
                </td>
                <td class="text-left">
                  {{ s.sectorName }}
                </td>
                <td>
                  {{ s.requestType || '-' }}
                </td>
                <td>
                  {{ s.requestStatus || '-' }}
                </td>
                <td>
                  {{ s.requestCount || '-' }}
                </td>
                <td>
                  {{ s.offerCount || '-' }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getCompanyRequestDynamics,
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";

import Multiselect from 'vue-multiselect'
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";
import {getWorkingSectors} from "@/repositories/GeneralDataRepository";
import dayjs from "dayjs";

import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    CompanyFormRequestStatus, Multiselect, CompanyFormStatus, Datepicker
  },
  data() {
    return {
      reportData: [],
      sectors: [],
      startDate: '',
      endDate: '',
      status: 'ALL',
      type: 'ALL',
      sector: 0,

      dateFormat: "yyyy-MM-dd",
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    startDateFormatted() {
      return dayjs(this.startDate).format('YYYY-MM-DD');
    },
    emdDateFormatted() {
      return dayjs(this.endDate).format('YYYY-MM-DD');
    },


  },
  watch: {
    startDate() {
      this.loadReportData();
    },
    endDate() {
      this.loadReportData();
    }
  },
  mounted() {

    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectors = ws.filter(s => s.parent === null);
    });

    this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
    this.endDate = dayjs().format('YYYY-MM-DD')

    this.loadReportData();
  },
  methods: {


    loadReportData() {
      getCompanyRequestDynamics(this.token, this.sector, this.startDateFormatted, this.emdDateFormatted, this.status, this.type)
          .then(({code, report}) => {
            if (code === 200) {
              this.reportData = report;
            }
          })
    },

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
